import HealthScoreIndicator from "./HealthScoreIndicator";
import CollapsableMetricsList from "./CollapsableMetricsList";
import { WellnessCategoryScoreSection } from "./WellnessCategoryScoreSection";
import type { MetricItem } from "./types";

type Props = {
  show: boolean;
  healthScore: number;
  metrics: MetricItem[];
  onMetricClick: (metric: MetricItem) => void;
  expanded: boolean;
  onExpandedChange: (expanded: boolean) => void;
};

export function WellnessScoreAndMetricsSection({
  show,
  healthScore,
  metrics,
  onMetricClick,
  expanded,
  onExpandedChange,
}: Props) {
  if (!show) {
    return null;
  }
  return (
    <WellnessCategoryScoreSection>
      <HealthScoreIndicator healthScore={healthScore} />
      <CollapsableMetricsList
        metrics={metrics}
        onMetricClick={onMetricClick}
        expanded={expanded}
        onExpandedChange={onExpandedChange}
      />
    </WellnessCategoryScoreSection>
  );
}
